// Бренд-акцент узгоджений із публічним застосунком (map.svitlofour.com,
// theme/accents.ts, EAccent.PUBLIC) — той самий зелений, а не дефолтний
// синій antd/Amplify.
export const colors = {
  primary: '#00b253',
  primaryHover: '#009e4a',
  primaryActive: '#00853e',
};
